// Framework-free (no react/styled), so this is the single source shared with the
// workspace Footer via the `webform/components/Footer/socialMediaLinks` path alias.
// The Footer components themselves are duplicated (MUI monolith vs Clay workspace), but
// the social-media URLs must stay identical, so they live here.
import {BrandEnum} from "utils/brand";

export enum SocialMediaOptions {
    FACEBOOK,
    X,
    INSTAGRAM,
}

export const SocialMediaLinks = {
    [BrandEnum.BOLT]: {
        [SocialMediaOptions.FACEBOOK]:
            "https://www.facebook.com/Bolt?utm_source=app&utm_medium=footer&utm_campaign=cs-social&utm_content=fb",
        [SocialMediaOptions.INSTAGRAM]:
            "https://www.instagram.com/bolt/?utm_source=app&utm_medium=footer&utm_campaign=cs-social&utm_content=ig",
        [SocialMediaOptions.X]:
            "https://x.com/Boltapp?utm_source=app&utm_medium=footer&utm_campaign=cs-social&utm_content=tw",
    },
    [BrandEnum.HOPP]: {
        [SocialMediaOptions.FACEBOOK]:
            "https://www.facebook.com/hopprides?utm_source=app&utm_medium=footer&utm_campaign=cs-social&utm_content=fb",
        [SocialMediaOptions.INSTAGRAM]:
            "https://www.instagram.com/hopprides/?utm_source=app&utm_medium=footer&utm_campaign=cs-social&utm_content=ig",
        [SocialMediaOptions.X]:
            "https://x.com/hoppsupport?utm_source=app&utm_medium=footer&utm_campaign=cs-social&utm_content=tw",
    },
};
